// import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import MensajeToken from '../MensajeToken/MensajeToken';
// import InputBusquedaArticulo from '../InputBusquedaArticulo/InputBusquedaArticulo';
// import CardArticulo from '../CardArticulo/CardArticulo';
// import ModalArticulo from '../ModalArticulo/ModalArticulo';
// import Paginacion from '../Paginacion/Paginacion';


// export default function Articulos({ logout }) {

//     const navigate = useNavigate();

//     const [articulos, setArticulos] = useState([]);
//     const [mensajeError, setMensajeError] = useState('');
//     const [searchTerm, setSearchTerm] = useState('');
//     const [page, setPage] = useState(1);
//     const [totalArticulos, setTotalArticulos] = useState(0);
//     const [itemsPerPage] = useState(6);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedArticulo, setSelectedArticulo] = useState(null);
//     const [toggleMenu, setToggleMenu] = useState(false);


//     useEffect(() => {
//         fetchData();
//     }, [page, searchTerm]);

//     const fetchData = async () => {
//         const token = localStorage.getItem('auth_usuario');

//         if (!token) {
//             navigate('/login');
//         }

//         try {
//             const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/articulo`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//                 params: {
//                     limit: itemsPerPage,
//                     offset: (page - 1) * itemsPerPage,
//                     searchTerm, // Enviar el término de búsqueda al backend
//                 }
//             });

//             setArticulos(response?.data.articulos);
//             setTotalArticulos(response?.data.total);
//             setMensajeError('');

//         } catch (error) {

//             setMensajeError(error.response?.data?.message || 'Ocurrió un error al obtener los artículos.');
//             setToggleMenu(!toggleMenu)
//             setTimeout(() => {
//                 localStorage.removeItem('auth_usuario');
//                 navigate('/login');
//             }, 10000);

//         }
//     };

//     const handleSearchChange = (e) => {
//         setSearchTerm(e.target.value);
//         setPage(1);  // Reiniciar a la primera página al cambiar el término de búsqueda
//     };

//     const handlePreviousPage = () => {
//         if (page > 1) setPage(page - 1);
//     };

//     const handleNextPage = () => {
//         if (page < Math.ceil(totalArticulos / itemsPerPage)) setPage(page + 1);
//     };

//     const openModal = (articulo) => {
//         setSelectedArticulo(articulo);
//         setShowModal(true);
//     };

//     const closeModal = () => {
//         setShowModal(false);
//         setSelectedArticulo(null);
//     };


//     const clearInput = () => {
//         setSearchTerm('')
//     }


//     return (
//         <div className='lg:container lg:mx-auto lg:flex lg:flex-col lg:min-h-screen justify-center items-center'>

//             <InputBusquedaArticulo searchTerm={searchTerm} handleSearchChange={handleSearchChange} clearInput={clearInput} />


//             <div className='grid grid-cols-1 gap-2 lg:grid lg:grid-cols-2 lg:gap-6 '>

//                 <CardArticulo articulos={articulos} openModal={openModal} />
//             </div>


//             {
//                 totalArticulos === 0 && (
//                     <div className='flex justify-center items-center mt-6'>
//                         <p className='text-center text-lg font-bold text-red-500'>¡NO SE ENCUENTRA EL ARTICULO!</p>
//                     </div>
//                 )
//             }

//             {totalArticulos > 5 && (
//                 <Paginacion articulos={articulos} page={page} totalArticulos={totalArticulos} handlePreviousPage={handlePreviousPage} handleNextPage={handleNextPage} itemsPerPage={itemsPerPage} />
//             )}

//             {/* Modal para mostrar detalles del artículo */}
//             {showModal && selectedArticulo && (
//                 <ModalArticulo selectedArticulo={selectedArticulo} closeModal={closeModal} />
//             )}

//             {toggleMenu && <MensajeToken mensajeError={mensajeError} logout={logout} />}

//         </div>
//     );

// }

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MensajeToken from '../MensajeToken/MensajeToken';
import InputBusquedaArticulo from '../InputBusquedaArticulo/InputBusquedaArticulo';
import CardArticulo from '../CardArticulo/CardArticulo';
import ModalArticulo from '../ModalArticulo/ModalArticulo';
import Paginacion from '../Paginacion/Paginacion';

export default function Articulos({ logout, vistaModal }) {
    const navigate = useNavigate();
    const [articulos, setArticulos] = useState([]);
    const [mensajeError, setMensajeError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [totalArticulos, setTotalArticulos] = useState(0);
    const [itemsPerPage] = useState(3);
    const [showModal, setShowModal] = useState(false);
    const [selectedArticulo, setSelectedArticulo] = useState(null);
    const [toggleMenu, setToggleMenu] = useState(false);

    useEffect(() => {
        fetchData();
    }, [page, searchTerm]);

    const fetchData = async () => {
        const token = localStorage.getItem('auth_usuario');
        if (!token) {
            navigate('/login');
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/articulo`, {
                headers: { Authorization: `Bearer ${token}` },
                params: {
                    limit: itemsPerPage,
                    offset: (page - 1) * itemsPerPage,
                    searchTerm,
                }
            });
            setArticulos(response?.data.articulos);
            setTotalArticulos(response?.data.total);
            setMensajeError('');
        } catch (error) {
            setMensajeError(error.response?.data?.message || 'Ocurrió un error al obtener los artículos.');
            setToggleMenu(true);
            setTimeout(() => {
                localStorage.removeItem('auth_usuario');
                navigate('/login');
            }, 10000);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setPage(1);
    };

    const handlePreviousPage = () => { if (page > 1) setPage(page - 1); };
    const handleNextPage = () => { if (page < Math.ceil(totalArticulos / itemsPerPage)) setPage(page + 1); };

    const openModal = (articulo) => {
        setSelectedArticulo(articulo);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedArticulo(null);
    };

    const clearInput = () => { setSearchTerm('') }

    return (
        <div className='flex flex-1 flex-col bg-slate-50 dark:bg-slate-950'>
            {/* Buscador fijo bajo la barra superior */}
            <InputBusquedaArticulo
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                clearInput={clearInput}
            />

            {/* En PC el contenido queda centrado en la pantalla */}
            <div className='mx-auto flex w-full max-w-6xl flex-1 flex-col px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-4 sm:px-6 lg:justify-center lg:px-8 lg:py-8'>
                {/* Resumen de resultados */}
                {totalArticulos > 0 && (
                    <p className='mb-3 text-sm text-slate-500 dark:text-slate-400 lg:text-center'>
                        <span className='font-semibold text-slate-700 dark:text-slate-200'>{Number(totalArticulos).toLocaleString('es-AR')}</span>{' '}
                        {Number(totalArticulos) === 1 ? 'artículo' : 'artículos'}
                        {searchTerm && <> para “<span className='font-medium text-slate-700 dark:text-slate-200'>{searchTerm}</span>”</>}
                    </p>
                )}

                {/* Tarjetas (centradas aunque haya 1 o 2) */}
                <div className='flex flex-wrap justify-center gap-3 md:gap-4'>
                    <CardArticulo articulos={articulos} openModal={openModal} />
                </div>

                {/* Estado vacío */}
                {totalArticulos === 0 && (
                    <div className='mx-auto mt-8 flex w-full max-w-lg flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center dark:border-slate-700 dark:bg-slate-900 lg:mt-0'>
                        <div className='mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500'>
                            <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                        </div>
                        <p className='text-base font-semibold text-slate-700 dark:text-slate-200'>Sin resultados</p>
                        <p className='mt-1 max-w-xs text-sm text-slate-500 dark:text-slate-400'>No se encontraron artículos que coincidan con tu búsqueda.</p>
                    </div>
                )}

                {/* Paginación */}
                <div className='mt-5'>
                    {totalArticulos > itemsPerPage && (
                        <Paginacion
                            articulos={articulos}
                            page={page}
                            totalArticulos={totalArticulos}
                            handlePreviousPage={handlePreviousPage}
                            handleNextPage={handleNextPage}
                            itemsPerPage={itemsPerPage}
                        />
                    )}
                </div>

                {/* Modales y Mensajes */}
                {showModal && selectedArticulo && (
                    <ModalArticulo selectedArticulo={selectedArticulo} closeModal={closeModal} vista={vistaModal} />
                )}
                {toggleMenu && <MensajeToken mensajeError={mensajeError} logout={logout} />}
            </div>
        </div>
    );
}
